import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

interface Props {
  message: string;
}

// TBD replace and then remove
const ErrorComponent: FunctionComponent<Props> = ({ message }) => {
  return (
    <div className="flex w-full text-red-600">
      <Typography>{message}</Typography>
    </div>
  );
};

export default ErrorComponent;
